import { nativeCall, wrapFailure, wrapSuccess } from "../utils/windVane";
import $script from "../utils/scriptjs";
var windVaneLoader = function(fn) {
    if (window.lib && window.lib.windvane) {
        return fn({
            nativeCall: nativeCall,
            wrapFailure: wrapFailure,
            wrapSuccess: wrapSuccess
        });
    } else {
        $script('//g.alicdn.com/mtb/lib-windvane/3.0.6/windvane.js', function() {
            return fn({
                nativeCall: nativeCall,
                wrapFailure: wrapFailure,
                wrapSuccess: wrapSuccess
            });
        });
    }
};
export default windVaneLoader;
